<template>
  <ul class="swipe-list podcast-list has-media no-bullet" v-if="loading">
    <li class="episode-link"
      v-for="i in loadingItemCount"
    >
      <div class="listitem"
        v-bind:class="{ 'media-right': !mediaLeft, 'media-left': mediaLeft }"
      >
        <div class="media"><a class="js-newpage" href=""
          @click.prevent=""
        ><img class="round-sm" :src="constants.phImg70x70" alt=""></a></div>
        <div class="media-body">
          <h3 class="h2-s"><a class="js-newpage ph-text" href=""
            @click.prevent=""
          >■■■■■■■■■■■■</a></h3>
          <div class="label ph-text">■■■■■■■■■</div>
          <div class="quiet small">
            <time datetime="" class="ph-text">■■■■■■■■</time>
            <span class="duration ph-text">■■■■■■■■</span>
          </div>
        </div>
      </div>
    </li>
  </ul>
  <ul class="swipe-list podcast-list has-media no-bullet" @touchstart="onTouchStart" @touchmove="onTouchMove" @touchend="onTouchEnd" v-else>
    <li class="episode-link"
      v-for="episode in episodes"
      :key="episode.id"
    >
      <div class="listitem"
        v-bind:class="{ 'media-right': !mediaLeft, 'media-left': mediaLeft }"
      >
        <div class="media" v-if="currentUser && currentUser.listen_progresses && currentUser.listen_progresses[episode.id.toString()]"><a class="js-newpage" href=""
          @click.prevent="navigatorPush('Episode', { id: episode.id, title: episode.title })"
        >
          <img-with-placeholder :src="constants.phImg70x70" :data-src="sizeImg(episode.image_base_url, 70, 70)" :alt="episode.image.alt_text" v-if="episode.image" />
          <img-with-placeholder :src="constants.phImg70x70" :data-src="sizeImg(episode.channel.image_base_url, 70, 70)" :alt="episode.channel.image.alt_text" v-else-if="!channel" />
        </a><div class="progress-bar-2"><span v-bind:style="{ width: (episode.duration ? 100*currentUser.listen_progresses[episode.id.toString()]/episode.duration : 50) + '%' }"></span></div></div>
        <div class="media" v-else><a class="js-newpage" href=""
          @click.prevent="navigatorPush('Episode', { id: episode.id, title: episode.title })"
        >
          <img-with-placeholder class="round-sm" :src="constants.phImg70x70" :data-src="sizeImg(episode.image_base_url, 70, 70)" :alt="episode.image.alt_text" v-if="episode.image" />
          <img-with-placeholder class="round-sm" :src="constants.phImg70x70" :data-src="sizeImg(episode.channel.image_base_url, 70, 70)" :alt="episode.channel.image.alt_text" v-else-if="!channel" />
        </a></div>
        <div class="media-body">
          <h3 class="h2-s"><a class="js-newpage" href=""
            @click.prevent="navigatorPush('Episode', { id: episode.id, title: episode.title })"
          >{{ episode.title }}</a></h3>
          <div class="label" v-if="!channel && episode.channel">{{ episode.channel.title }}</div>
          <div class="quiet small">
            <time :datetime="timestampToDate(episode.published_at)">{{ episode.published_at | timestampHumanizeFromNow | titleize }}, </time>
            <span class="duration" v-if="currentUser && currentUser.listen_progresses && currentUser.listen_progresses[episode.id.toString()]">
              {{ $t(`episode.duration_${episode.duration ? "left" : "listened"}`, { duration: $options.filters.secondsToDuration(Math.abs(episode.duration - currentUser.listen_progresses[episode.id.toString()])) }) }}
            </span>
            <span class="duration" v-else>{{ episode.duration | secondsToDuration }}</span>
          </div>
        </div>
        <div class="action-btn-group"
          v-bind:class="{
            'btns-2': !subscribeButtonEnabled,
            'btns-3': subscribeButtonEnabled
          }"
        >
          <button class="play js-player-toggle action-btn flat-button icon-md icon-only default-action"
            v-bind:class="{ switched: episode.id === player.episodeId && player.playing, buffering: episode.id === player.episodeId && player.buffering }"
            @click="playOrPause(episode, episode.channel || channel)"
          >
            <span>
              <icon-play-white />
              <span class="txt">{{ (episode.id === player.episodeId && player.playing) ? $t("episode.pause") : $t("episode.play") }}</span>
            </span>
          </button>

          <button class="download action-btn flat-button icon-md icon-only"
            v-bind:class="{ pending: episode._download_status === 'PENDING', switched: episode._download_status === 'DOWNLOADING', complete: !showDelete && episode._download_status === 'DOWNLOADED', delete: showDelete && episode._download_status === 'DOWNLOADED' }"
            @click="downloadOrCancel(episode, episode.channel || channel)"
          >
            <span>
              <icon-delete v-if="showDelete && episode._download_status === 'DOWNLOADED'" />
              <icon-download :episode="episode" v-else />
              <span class="txt" v-if="episode && episode._download_status === 'DOWNLOADING'">{{ episode._download_progress === 1 ? $t("episode.download.processing") : '' + Math.round(episode._download_progress*100) + '%' }}</span>
              <span class="txt" v-else-if="episode && episode._download_status === 'PENDING'">{{ $t("episode.download.pending") }}</span>
              <span class="txt" v-else-if="episode && episode._download_status === 'DOWNLOADED'">{{ $t("episode.download.downloaded") }}</span>
              <span class="txt" v-else>{{ $t("episode.download.default") }}</span>
            </span>
          </button>

          <button class="unsubscribe action-btn flat-button icon-md icon-only"
            :disabled="channelLoading[episode.channel.id]"
            v-bind:class="{ switched: episode.channel && episode.channel.is_subscribed }"
            @click="toggleSubscribe(episode.channel)"
            v-if="subscribeButtonEnabled"
          >
            <span>
              <icon-unsubscribe />
              <span class="txt">{{ (episode.channel && episode.channel.is_subscribed) ? $t("channel.unsub") : $t("channel.sub") }}</span>
            </span>
          </button>
        </div>
        <div class="tabbar__badge notification" v-show="unreadNewEpisodesCheckedAt <= episode.published_at">&nbsp;</div>
      </div>
    </li>
  </ul>
</template>

<script>
import PlayerHelper from '@/mixins/PlayerHelper';
import DownloadHelper from '@/mixins/DownloadHelper';

let whichProperty = (props) => {
  if (typeof props === 'string') {
    var arr = [props],
        Props = props.charAt(0).toUpperCase() + props.substr(1),
        prefixes = ['Webkit', 'Moz', 'ms', 'O'];

    prefixes.forEach(function(prefix) {
      if (prefix !== 'ms' || props === 'transform') {
        arr.push(prefix + Props);
      }
    });

    props = arr;
  }

  var el = document.createElement('fakeelement'),
      len = props.length;
  for(var i = 0; i < props.length; i++){
    var prop = props[i];
    if( el.style[prop] !== undefined ){ return prop; }
  }

  return false; // explicit for ie9-
};

let lookupByClass = (el, cla) => {
  if (el === body) { return null; }
  return el.classList && el.classList.contains(cla) ? el : lookupByClass(el.parentNode, cla);
};
let toDegree = (y, x) => {
  return Math.atan2(y, x) * (180 / Math.PI);
};
let isHorizontal = (angle, range) => {
  var direction = false,
      gap = Math.abs(90 - Math.abs(angle));
  return gap >= (90 - range);
};

let swipeAngle = 40;
let swipeDirectionExpected = '?';
let execCl = 'exec';
let TRANSFORM = whichProperty('transform');
let TRANSITION = whichProperty('transition');

export default {
  props: ['episodes', 'channel', 'loading', 'loadingItemCount', 'subscribeButtonEnabled', 'onToggleSubscribeStart', 'onToggleSubscribeError', 'onToggleSubscribeEnd', 'channelLoading', 'setChannelLoading', 'unreadNewEpisodesCheckedAt', 'mediaLeft', 'showDelete'],
  mixins: [PlayerHelper, DownloadHelper],

  data() {
    return {
      swipeTarget: null,
      swipeExecThreshold: null,
      swipeDefaultButtonEl: null,
      swipeStartX: null,
      swipeStartY: null,
      swipeInitX: null,
      swipeDirectionExpected: null,
    };
  },

  methods: {
    onTouchStart(e) {
      this.swipeTarget = lookupByClass(e.target, 'listitem');
      if (!this.swipeTarget) { return; }

      let group = this.swipeTarget.querySelector('.action-btn-group');
      if (!group) { return; }
      let btnWidth = group.querySelector('.action-btn').offsetWidth;
      this.swipeExecThreshold = btnWidth * group.querySelectorAll('.action-btn').length + 30;
      this.swipeDefaultButtonEl = group.querySelector('.default-action') || group.querySelector('.action-btn');

      let transformX = this.swipeTarget.style.transform;
      this.swipeStartX = e.changedTouches[0].clientX;
      this.swipeStartY = e.changedTouches[0].clientY;
      if (transformX) {
        this.swipeInitX = parseInt(transformX.replace('translateX(', '').replace('px)', ''));
      } else {
        this.swipeInitX = 0;
      }
    },
    onTouchMove(e) {
      if (!this.swipeTarget) { return; }
      let disX = e.changedTouches[0].clientX - this.swipeStartX;
      let disY = e.changedTouches[0].clientY - this.swipeStartY;
      let disXFinal = disX + this.swipeInitX;
      if (this.swipeDirectionExpected === null) {
        this.swipeDirectionExpected = isHorizontal(toDegree(disY, disX), 40);
      }
      if (!this.swipeDirectionExpected) { return; }
      this.swipeTarget.style = TRANSFORM + ': translate(' + Math.max(0, disXFinal) + 'px, 0);';
      if (disXFinal >= this.swipeExecThreshold) {
        if (this.swipeTarget.classList.contains(execCl)) { return; }
        this.swipeTarget.classList.add(execCl);
      } else {
        if (!this.swipeTarget.classList.contains(execCl)) { return; }
        this.swipeTarget.classList.remove(execCl);
      }
    },
    onTouchEnd(e) {
      let swipeTarget = this.swipeTarget;
      let swipeExecThreshold = this.swipeExecThreshold;
      let swipeDefaultButtonEl = this.swipeDefaultButtonEl;
      let swipeDirectionExpected = this.swipeDirectionExpected;
      let swipeStartX = this.swipeStartX;
      let swipeStartY = this.swipeStartY;
      let swipeInitX = this.swipeInitX;

      this.swipeTarget = null;
      this.swipeExecThreshold = null;
      this.swipeDefaultButtonEl = null;
      this.swipeDirectionExpected = null;
      this.swipeStartX = null;
      this.swipeStartY = null;
      this.swipeInitX = null;

      if (!swipeTarget) { return; }
      if (!swipeDirectionExpected) { return; }

      let disX = e.changedTouches[0].clientX - swipeStartX;
      let disY = e.changedTouches[0].clientY - swipeStartY;
      let disXFinal = disX + swipeInitX;
      let n = disX > 0 && disXFinal > 30 && disXFinal < swipeExecThreshold ? swipeExecThreshold - 30 : 0;

      swipeTarget.style = TRANSITION + ': transform 0.25s; ' + TRANSFORM + ': translateX(' + n + 'px);';

      if (swipeTarget.classList.contains(execCl)) {
        window.setTimeout(() => {
          swipeTarget.classList.remove(execCl);
        }, 300);
      }

      if (disXFinal >= swipeExecThreshold) {
        swipeDefaultButtonEl.click();
      }
    },
    toggleSubscribe(channel) {
      if (!this.checkAndShowRequireLoginToast()) { return; }
      if (this.showGoOnlineToast(this.$t("messages.go_online_to_sub"))) { return; }
      if (this.onToggleSubscribeStart) { setTimeout(() => { this.onToggleSubscribeStart(); }, 0); }
      if (this.setChannelLoading) { this.setChannelLoading(channel.id, true); }
      channel.toggleSubscribe(this.currentUser.id)
        .then(() => {
          this.currentUser.updateSubscriptionsChanged(true);
        }).catch((error) => {
          if (this.onToggleSubscribeError) { setTimeout(() => { this.onToggleSubscribeError(error); }, 0); }
        })
        .finally(() => {
          if (this.setChannelLoading) { this.setChannelLoading(channel.id, false); }
          if (this.onToggleSubscribeEnd) { setTimeout(() => { this.onToggleSubscribeEnd(); }, 0); }
          this.$forceUpdate();
          if (channel.is_subscribed) { this.askPushNotification(); }
        });
    },
  },
};
</script>
